import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchBranchesData = createAsyncThunk(
    "branch/fetchData",
    async () => {
        try {
            const response = await api.get("/branch");
            if (response.data?.status === "success") {
                const data = response.data.data;
                return data;
            }
        } catch (error) {
            return error;
        }
    }
);

export const branchSlice = createSlice({
    name: "branch",
    initialState: {
        loading: false,
        error: null,
        branches: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBranchesData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBranchesData.fulfilled, (state, action) => {
                state.loading = false;
                state.branches = action.payload;
            })
            .addCase(fetchBranchesData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },

});

export default branchSlice.reducer;

